import { useLocation } from 'react-router-dom'

function usePath() {
    const location = useLocation()

    const pathSections = location.pathname.split('/').filter(Boolean)
    const path = pathSections.reduce(
        (prevValue, item) =>
            prevValue +
            (item
                ? item.match(/^[0-9a-fA-F]{24}$/)
                    ? '/:id'
                    : item.match(/^[0-9a-fA-F]{300,700}$/)
                    ? '/:token'
                    : '/' + item
                : ''),
        ''
    )

    const splitedRoute = path.split('/').filter(Boolean)
    const pathRoute = '/' + (splitedRoute.length ? splitedRoute[0] : '')

    const pathEquality = (paths: string[]): boolean => {
        let inStepLayput = false
        paths.forEach(item => {
            if (path.includes(item)) {
                inStepLayput = true
            }
        })
        return inStepLayput
    }

    return {
        path,
        pathRoute,
        pathEquality,
        pathSections
    }
}

export default usePath
